import { Label } from "../../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";

export const Field = ({ label, children, className = "" }) => (
  <div className={className}>
    <Label className="text-[10px] tracking-wider uppercase text-[#676664]/60">{label}</Label>
    <div className="mt-1">{children}</div>
  </div>
);

export function Pick({ value, onChange, options, testid, placeholder = "Choose" }) {
  return (
    <Select value={value || "__none"} onValueChange={(v) => onChange(v === "__none" ? "" : v)}>
      <SelectTrigger className="h-9 text-[12px]" data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value || "__none"} value={o.value || "__none"} data-testid={`${testid}-opt-${o.value || "none"}`}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const Section = ({ title, children, testid }) => (
  <div className="border border-[#282828]/8 bg-white p-4 space-y-3" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-[0.14em] text-[#9A7B4F] font-medium">{title}</div>
    {children}
  </div>
);
